export const CAMPAIGN_DISCOUNT_RATE = 0.2;
export const CAMPAIGN_DISCOUNT_PERCENT = 20;
export const CAMPAIGN_LABEL = "20% kampanjrabatt";
export const CAMPAIGN_DETAILS = "Gäller nya bokningar och dras från priset i offert eller checkout. Kan inte kombineras med andra rabatter; högsta tillämpliga rabatt gäller.";

export const campaignPrice = (amount) => Math.round(amount * (1 - CAMPAIGN_DISCOUNT_RATE));